import { render, staticRenderFns } from "./WhatWeNeed.vue?vue&type=template&id=343eed89&"
import script from "./WhatWeNeed.vue?vue&type=script&lang=ts&"
export * from "./WhatWeNeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports